"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMobileDragDropPolyfill;

var _react = require("react");

var _mobileDragDrop = require("mobile-drag-drop");

// polyfill to enable html5 native drag&drop on touch devices
let _polyfill_applied = false;

function useMobileDragDropPolyfill(DRAGGABLE_CLASS) {
  (0, _react.useEffect)(() => {
    if (_polyfill_applied) return;

    if (typeof document !== "undefined" && typeof window !== "undefined") {
      (0, _mobileDragDrop.polyfill)({
        // limit polyfill to dragabble class items
        dragStartConditionOverride: ev => {
          if (ev.target.parentNode.classList.contains(DRAGGABLE_CLASS)) return true;else return false;
        }
      }); // workaround for iOS Safari (see https://github.com/timruffles/mobile-drag-drop/issues/77)

      window.addEventListener("touchmove", function () {}, {
        passive: false
      });
      _polyfill_applied = true;
    }
  }, [DRAGGABLE_CLASS]);
}